module.exports = __webpack_public_path__ + "static/img/logo-inline.a224541.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo-inline.png
// module id = jGMP
// module chunks = 1